import { Button } from 'antd';
import { Plus, ShieldAlert } from 'lucide-react';
import { Navigate } from 'react-router';
import { EmptyState } from '../../../shared/components/EmptyState';
import { TableSkeleton } from '../../../shared/components/TableSkeleton';
import { useExpensesPage } from '../hooks/use-expenses-page';
import { ExpensesTable } from './ExpensesTable';
import { RecordExpenseDrawer } from './RecordExpenseDrawer';

/** Every expense, with the button to record one for a driver. */
export function AllExpensesTab() {
  const page = useExpensesPage();

  if (page.state.status === 'forbidden') return <Navigate to="/" replace />;

  return (
    <>
      {page.canRecord && (
        <div className="mb-4 flex justify-end">
          <Button type="primary" icon={<Plus className="size-4" />} onClick={page.openDrawer}>
            Record expense
          </Button>
        </div>
      )}
      {page.state.status === 'error' && (
        <EmptyState icon={ShieldAlert} title="Couldn't load expenses" description="Something went wrong loading the expenses. Try reloading the page." />
      )}
      {page.state.status === 'loading' && <TableSkeleton label="Loading expenses" withSearch />}
      {page.state.status === 'loaded' && <ExpensesTable page={page.state.page} columns={page.columns} list={page.list} isRefreshing={page.isRefreshing} />}
      <RecordExpenseDrawer
        open={page.drawerOpen}
        categories={page.categories}
        error={page.error}
        submitting={page.submitting}
        onRecord={page.record}
        onClose={page.closeDrawer}
      />
    </>
  );
}
